import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgChatQuestion = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M12.6018 3.00013C11.1049 2.99798 9.6346 3.39646 8.34361 4.15425C7.05262 4.91203 5.98794 6.00149 5.26007 7.30958C4.53219 8.61766 4.16764 10.0967 4.20424 11.5932C4.24085 13.0897 4.67727 14.5492 5.46823 15.8201L3.00183 21.0001L8.18102 18.5337C9.28558 19.2205 10.5345 19.6413 11.8295 19.7632C13.1244 19.885 14.4299 19.7045 15.6432 19.2358C16.8565 18.7671 17.9443 18.0231 18.821 17.0623C19.6978 16.1016 20.3394 14.9504 20.6955 13.6994C21.0515 12.4484 21.1121 11.1319 20.8727 9.85347C20.6332 8.57506 20.1001 7.36973 19.3154 6.33244C18.5307 5.29515 17.5159 4.45424 16.3509 3.87598C15.1859 3.29772 13.9025 2.99789 12.6018 3.00013V3.00013Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 9.21678C10.0001 8.76459 10.1245 8.32112 10.3596 7.93484C10.5947 7.54857 10.9314 7.23435 11.333 7.02653C11.7347 6.81871 12.1857 6.7253 12.6368 6.75649C13.0879 6.78768 13.5218 6.94227 13.891 7.20338C14.2601 7.46449 14.5505 7.82207 14.7302 8.23702C14.9099 8.65198 14.972 9.10835 14.9099 9.55625C14.8477 10.0042 14.6637 10.4264 14.3778 10.7767C14.0919 11.1271 13.7152 11.3921 13.2889 11.5428C13.0483 11.6279 12.84 11.7854 12.6928 11.9938C12.5455 12.2022 12.4665 12.4511 12.4666 12.7063V12.9167"
          stroke="currentColor"
          strokeWidth={1.24}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.4667 15.3629C12.4017 15.3629 12.3381 15.3821 12.284 15.4183C12.2299 15.4544 12.1877 15.5058 12.1629 15.5659C12.138 15.626 12.1314 15.6921 12.1441 15.7559C12.1568 15.8197 12.1882 15.8783 12.2341 15.9243C12.2801 15.9703 12.3387 16.0016 12.4025 16.0143C12.4663 16.027 12.5325 16.0205 12.5926 15.9956C12.6527 15.9707 12.704 15.9286 12.7402 15.8745C12.7763 15.8204 12.7956 15.7568 12.7956 15.6917C12.7956 15.6045 12.761 15.5209 12.6993 15.4592C12.6376 15.3975 12.5539 15.3629 12.4667 15.3629Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={1.32269}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgChatQuestion.displayName = 'SvgChatQuestion';
export default SvgChatQuestion;
